var _defs, _circle, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 212 162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-3, .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        fill: #e0e4e9;\n      }\n\n      .cls-4, .cls-2 {\n        stroke: #637b93;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 105.5,
    cy: 81,
    r: 76.54
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M123.23,56.53c1.01-1.15,1.94-2.38,2.75-3.69,5.89-9.69,11.98-16.34,16.34-18.51,1.82-.91,3.64-1.45,3.64-1.45,.3-.09,.59-.17,.87-.24,4.16-1.08,8.57-.73,12.61,.73,10.23,3.74,20.45,7.47,30.68,11.21,3.97,1.45,7.38,4.16,9.5,7.8l.05,.11c.72,1.26,1.28,2.5,1.68,3.67,1.01,2.92,1.33,6.03,1.07,9.13-.56,6.45-1.12,12.89-1.68,19.34-.73,8.47-3.81,16.53-8.83,23.37-2.55,3.48-5.28,7.01-8.2,10.58-3.17,3.87-6.33,7.5-9.44,10.9-1.52,1.73-5.09,5.28-10.9,7.26-6.23,2.12-11.56,1.22-13.8,.73-5-1.56-10.37-3.46-15.97-5.81-4.32-1.8-8.36-3.69-12.14-5.61-6.82-3.46-12.42-8.96-15.95-15.74-.31-.61-.65-1.24-.96-1.89-1.78-3.59-3.2-7.01-4.36-10.16-.58-2.1-1.12-5.12-.73-8.71,.91-8.34,6.21-13.63,7.99-15.25l15.78-17.75,.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99.46,89.53s-2.19,5.81,9.45,14.52c11.61,8.71,39.95,19.61,39.95,19.61,3.1,.94,7.15,1.61,11.61,.73,8.08-1.61,13.24-7.47,21.79-17.42,1.57-1.84,3.29-3.94,5.07-6.28,2.92-3.83,5.35-8.03,7.24-12.45,1-2.36,1.98-4.83,2.94-7.4,2.03-5.49,3.64-10.7,4.91-15.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.46,89.53s-2.19,5.81,9.45,14.52c11.61,8.71,39.95,19.61,39.95,19.61,3.1,.94,7.15,1.61,11.61,.73,8.08-1.61,13.24-7.47,21.79-17.42,1.57-1.84,3.29-3.94,5.07-6.28,2.92-3.83,5.35-8.03,7.24-12.45,1-2.36,1.98-4.83,2.94-7.4,2.03-5.49,3.64-10.7,4.91-15.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M175.72,74.28c-11.65-4.76-23.3-9.51-35.58-14.52,3.87-5.81,7.75-11.61,11.61-17.42,11.35,4.71,22.72,9.41,34.07,14.12-3.38,5.95-4.35,8.24-7.73,14.19l-2.38,3.63Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.64,114.65v-43.82c0-21.93,17.95-40.3,39.87-39.88,21.25,.41,38.35,17.76,38.35,39.11v44.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.64,114.65v-43.82c0-21.93,17.95-40.3,39.87-39.88,21.25,.41,38.35,17.76,38.35,39.11v44.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M93.15,111.12c-3.7,0-6.7-2.99-6.7-6.7v-8.85H53.08v8.85c0,3.7-2.99,6.7-6.7,6.7-20.36,0-36.87,16.5-36.87,36.87h0c0,1.11,.9,2.01,2.01,2.01H128c1.11,0,2.01-.9,2.01-2.01h0c0-20.36-16.5-36.87-36.87-36.87h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M95.95,69.59c-4.71-2.65-9.7-6.61-15.32-11.45-4.07-3.5-7.44-7-10.2-10.2-4.97,4.45-10.63,9.06-17.01,13.6-3.48,2.49-6.88,4.74-10.2,6.8-2.91,23.51,13.39,40.81,26.49,40.81s29.86-15.78,27.56-38.91l-1.31-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.37,111.12c.38,.74,7.23,13.34,21.5,14.36,10.33,.74,20.29-4.92,25.28-14.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.37,111.12c.38,.74,7.23,13.34,21.5,14.36,10.33,.74,20.29-4.92,25.28-14.36"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step-2.4b09ab71172e2cc1f34dc252d73aa216.svg";
export { ForwardRef as ReactComponent };